import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'

interface GetTemplateDashboardStatsParams {
	startDate?: string
	endDate?: string
	client?: string
}
export interface GetTemplateDashboardStatsResponse {
	approved: number
	draft: number
	request_to_approve: number
	pending: number
	rejected: number
	delete_request: number
	deleted: number
	paused: number
	disabled: number
	flagged: number
	in_appeal: number
	reinstated: number
}
export const getTemplateDashboardStats = async (
	params: GetTemplateDashboardStatsParams
): Promise<GetTemplateDashboardStatsResponse> => {
	try {
		const { data } = await axios.get('v1/template/management/template-stats', {
			params,
		})
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}
export default getTemplateDashboardStats
